import {
  useRuntimeEnv,
  useRuntimeEnvRolesIncludes,
  useTranslationLang,
  useTranslationRoute,
  useTranslations,
} from "@harea/component";
import { FileTextIcon, UsersIcon, ScrollTextIcon } from "lucide-react";
import { useMemo } from "react";

export const useLeftSideBarMenuAdminManagement = () => {
  const [EMPLOYEE, CONTRACT, DOCUMENT, DEBAUCHAGE, PERSONNEL] = useTranslations(i18n);
  const translationRoute = useTranslationRoute();
  const { lang } = useTranslationLang();
  const { runtimeEnv } = useRuntimeEnv()
  const rolesInclude = useRuntimeEnvRolesIncludes();
  const isManager = runtimeEnv?.user?.role === "MANAGER";
  const isAdmin = runtimeEnv?.user?.role === "DIRECTOR_HR" || runtimeEnv?.user?.role === "ADMIN";
  const canViewTree = rolesInclude(["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR", "EMPLOYEE_MANAGE"]);
  const canViewTeam = rolesInclude([
    "SUPER_ADMIN",
    "ADMIN",
    "DIRECTOR_HR",
    "MANAGER",
    "EMPLOYEE_MANAGE",
    "TEAM_VIEW",
  ]);

  return {
      ke: "general",
      label: PERSONNEL,
      className: "menu-item-category",
      items: [
        ...(isAdmin || isManager
          ? [
              {
                label: EMPLOYEE,
                startIcon: <UsersIcon />,
                link: translationRoute("admin/employees")
              },
            ]
          : []),
        ...(isAdmin
          ? [
              {
                label: CONTRACT,
                link: translationRoute("admin/contracts"),
                startIcon: <ScrollTextIcon />,
              },
              {
                label: DOCUMENT,
                link: translationRoute("admin/documents"),
                startIcon: <FileTextIcon />,
              },
              {
                label: DEBAUCHAGE,
                link: translationRoute("admin/debauchage"),
                startIcon: "fa-solid fa-business-time",
              },
            ]
          : []),
      ],
    }
};

const i18n = [
  "Generic.UserOrganisation.Users.title",
  "Generic.de.CONTRACT",
  "std_document",
  "std_debauchage",
  "std_personal",
];
